
import { defineComponent } from 'vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'
import Listbox from 'primevue/listbox'
import lovsManagementTreeDescriptor from './LovsManagementTreeDescriptor.json'

export default defineComponent({
    name: 'lovs-management-tree',
    components: { Column, DataTable, Dropdown, Listbox },
    props: {
        listData: {
            type: Object
        },
        treeModel: {
            type: Array
        }
    },
    emits: ['modelChanged'],
    data() {
        return {
            lovsManagementTreeDescriptor,
            data: {} as any,
            selectedValues: [] as any[],
            options: [] as any[]
        }
    },
    watch: {
        listData() {
            this.loadData()
            this.loadModel()
        },
        treeModel() {
            this.loadData()
            this.loadModel()
        }
    },
    created() {
        this.loadData()
        this.loadModel()
    },
    methods: {
        loadData() {
            this.data = this.listData
            this.options = []
            this.data.forEach((el: any) => this.options.push({ name: el.name, label: el.name }))
        },
        loadModel() {
            this.selectedValues = this.treeModel as any[]

            this.removeUnusedSelectedValues()
        },
        removeUnusedSelectedValues() {
            for (let i = 0; i < this.selectedValues.length; i++) {
                const index = this.data.findIndex((el: any) => el.name === this.selectedValues[i].value)
                if (index === -1) this.selectedValues.splice(i, 1)
            }
        },
        setSelectedValue(value: any) {
            const index = this.selectedValues.findIndex((el: any) => el.level === value.name)
            if (index === -1) {
                this.selectedValues.push({ level: value.name, value: value.name, description: value.name })
            }
            this.$emit('modelChanged', this.selectedValues)
        },
        removeValueConfirm(index: number) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.removeValue(index)
                }
            })
        },
        removeValue(index: number) {
            this.selectedValues.splice(index, 1)
            this.$emit('modelChanged', this.selectedValues)
        },
        onCellEditComplete(event: any) {
            this.selectedValues[event.index] = event.newData
        }
    }
})
